import firebase from "firebase";
import {deserialize} from "serializr";
import {InboxModel} from "@/modules/minbox/models/InboxModel";
import {InboxStoreUtils} from "@/modules/minbox/database/InboxStoreUtils";

export default {
    namespaced: true,
    state: {
        mInboxes: [],
    },
    getters: {
        getInboxes: state => {
            return state.mInboxes;
        },
    },
    mutations: {
        setInboxes(state, values) {
            state.mInboxes = values;
        },
    },
    actions: {
        init({/*commit*/}) {
            console.info('inbox-store initialized.');
            return InboxStoreUtils.fetchInboxes();
        },
        fetchInboxes({commit}) {
            let db = firebase.database();
            return Promise.all([
                db.ref("/inbox")
                    .once("value")
                    .then((snapshot) => {
                        let values = []
                        if (snapshot.val() != null){
                            //console.log(snapshot.val())
                            Object.keys(snapshot.val()).forEach(function(key) {
                                let o = deserialize(InboxModel, snapshot.val()[key])
                                o.key = key
                                values.push(o)
                            });
                        }
                        commit("setInboxes", values);
                        return Promise.resolve()
                    }),
            ]);
        },
        deleteInbox({/*commit*/}, key) {
            let db = firebase.database();
            return Promise.all([
                db.ref("/inbox").child(key)
                    .remove()
                    .then(() => {
                        return InboxStoreUtils.fetchInboxes();
                    }),
            ]);
        },
    }
}

